import * as React from 'react';

import './loading-image.component.css'

export interface ILoadingImageProps {
    src: string;
    onLoadCompleted(success: boolean): void;
    onLoadStarted(): void;
}

export interface ILoadingImageState {
    isLoading: boolean;
    isError: boolean;
}

/**
 * Image with error state with reload button
 */
export default class LoadingImage extends React.PureComponent<ILoadingImageProps,ILoadingImageState> {
    constructor(props: ILoadingImageProps) {
        super(props);
        this.state = {
            isLoading: true,
            isError: false
        };
    }

    private onImageLoaded() {
        this.setState({
            isLoading: false,
            isError: false
        });

        this.props.onLoadCompleted(true);
    }

    private onImageError(err: React.SyntheticEvent<HTMLImageElement>) {
        this.setState({
            isLoading: false,
            isError: true
        });

        this.props.onLoadCompleted(false);
    }

    private onReloadImage() {
        this.setState({
            isError: false,
            isLoading: true
        });

        this.props.onLoadStarted();
    }

    public render() {
        let content: any;
        if (this.state.isError) {
            content = (
                <div className="image-load-failed">
                    <div className="error">
                        <span>Failed to load image</span>
                    </div>
                    <div className="reload">
                        <button
                            className="btn btn-outline-danger"
                            onClick={() => this.onReloadImage()}
                        >
                            Reload
                        </button>
                    </div>
                </div>
            );
        } else {
            content = (
                <img
                    src={this.props.src}
                    onLoad={() => this.onImageLoaded()}
                    onError={err => this.onImageError(err)}
                    draggable={false}
                />
            );
        }

        return content;
    }
}



// WEBPACK FOOTER //
// ./src/App/shared/components/gallery/loading-image.component.tsx